import { render } from "./OrganizationsView.vue?vue&type=template&id=09cb6634&scoped=true"
import script from "./OrganizationsView.vue?vue&type=script&lang=js"
export * from "./OrganizationsView.vue?vue&type=script&lang=js"

import "./OrganizationsView.vue?vue&type=style&index=0&id=09cb6634&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09cb6634"]])

export default __exports__